// Tee vertex schema
// A tee fitting where a branch pipe joins a run pipe

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

/**
 * Tee Vertex Schema
 * A tee fitting where a branch pipe joins a run pipe.
 * Simple passive connection point (like junction) with additional
 * tee-specific fields for future K-value calculations.
 *
 * @property elevation - Height of the tee fitting
 * @property tee_type - Whether this is the branch or run side (for K-value calc)
 * @property angle - Branch angle in degrees (default 90)
 */
export const TeeVertexSchema = BaseVertexSchema.extend({
  type: z.literal('tee'),
  elevation: ValueWithUnitSchema,
  tee_type: z.enum(['branch', 'run']).optional(),
  angle: ValueWithUnitSchema.optional(), // branch angle, default 90 deg
});

export type TeeVertex = z.infer<typeof TeeVertexSchema>;
